import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import css from './CheckBackSoon.scss';
import ServiceCard from './ServiceCard';
import CheckInSchedule from './CheckInSchedule';
import { SFVirtualCheckInDaySchedule, SFService } from 'utils/types';

/**
 * This page provides schedule details and service information about a virtual kiosk in the event that a student
 * attempts to access it outside of the open hours.
 *
 * @param {SFService[]} kioskServices - the services associated with the kiosk
 * @param {string} tenantTimezone - the timezone being used for the displayed hours
 * @param {SFVirtualCheckInDaySchedule[]} virtualCheckInSchedule - the days and hours for which the virtual kiosk is open
 * @returns {JSX.Element} - the page displaying all of the information about the closed kiosk.
 */
const CheckBackSoon = ({ kioskServices, tenantTimezone, virtualCheckInSchedule }) => {
    return (
        <div className={css['container']}>
            <img src={'../images/starfish/check_back_soon.jpg'} alt={'Check back soon'}/>
            <div className={css['header']}>Sorry we missed you!</div>
            <div className={css['message']}>
                We&apos;re not available for virtual check-in right now.<br />
                Come back during our Virtual Check-in Hours below or visit a service
                for appointment scheduling and contact information.
            </div>
            <div className={css['kiosk-details']}>
                <div className={css['section']}>
                    <div className={css['title']}>Virtual Check-in Hours</div>
                    <div className={css['instructions']}>
                        Shown in Time Zone: <span className={css['time-zone']}>{tenantTimezone}</span>
                    </div>
                    <CheckInSchedule virtualCheckInSchedule={virtualCheckInSchedule} />
                </div>
                <div className={css['section']}>
                    <div className={css['title']}>Visit Services</div>
                    <div className={css['instructions']}>
                        For current students only
                    </div>
                    <div className={css['service-details']}>
                        {kioskServices.map((service) => <ServiceCard service={service} key={service.id} />)}
                    </div>
                </div>
            </div>
        </div>
    );
}

CheckBackSoon.propTypes = {
    kioskServices: PropTypes.arrayOf(SFService).isRequired,
    tenantTimezone: PropTypes.string.isRequired,
    virtualCheckInSchedule: PropTypes.arrayOf(SFVirtualCheckInDaySchedule).isRequired
}

export default hot(CheckBackSoon);
